import React, { useState, useEffect } from "react";
import amaxLogo from "../../images/amaxLogoWhite.png";
import arrowNext from "../../images/arrowNext.svg"; // Ensure correct path to arrowNext
import { useNavigate } from "react-router-dom";
import API_URL from "../../api/API";

export const AthleteStep1 = () => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [secureCode, setSecureCode] = useState("");
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // Restore data from sessionStorage
    const firstname_ = sessionStorage.getItem("firstname");
    const lastname_ = sessionStorage.getItem("lastname");
    const phonenumber_ = sessionStorage.getItem("phonenumber");
    if (firstname_) setFirstname(firstname_);
    if (lastname_) setLastname(lastname_);
    if (phonenumber_) setPhonenumber(phonenumber_);
  }, []);

 /* const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!firstname || !lastname || !phonenumber) {
      setError("Please enter all the details!");
      setMsg(null);
      return;
    }
    if (!secureCode) {
      setError("Please enter the secure access code.");
      return;
    }

    try {
        setLoading(true);
        setError(null);

        const response = await fetch(API_URL.VERIFY_SECURE_CODE, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ code: secureCode }),
        });

        const data = await response.json();

        if (!data.valid) {
          setError("Invalid secure access code.");
          setLoading(false);
          return;
        }
 
        // Navigate to the second step with the form data
        //save the data in session
        sessionStorage.setItem("firstname", firstname);
        sessionStorage.setItem("lastname", lastname);
        sessionStorage.setItem("phonenumber", phonenumber);

    navigate("/athlete/register/step2");

  } catch (err) {
    setError("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
  };*/

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Basic validation
    if (!firstname || !lastname || !phonenumber) {
      setError("Please enter all the details!");
      setMsg(null);
      return;
    }
  
    try {
      setLoading(true);
      setError(null);
  
      // Save data in session
      sessionStorage.setItem("firstname", firstname);
      sessionStorage.setItem("lastname", lastname);
      sessionStorage.setItem("phonenumber", phonenumber);
  
      navigate("/athlete/register/step2");
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-[20px] bg-white h-dvh overflow-hidden">
    <div className="w-full max-w-2xl mx-auto h-full flex flex-col items-center gap-8 overflow-y-auto">



        <a href="/" className="size-[96px] lg:size-[166px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </a>
        {/*<div className="bg-gray-100 rounded-2xl p-4 text-sm text-gray-700">
  <p className="font-semibold mb-1">
    Have a Secure Access Code?
  </p>
  <p>
    Enter your secure code below to begin registration immediately.
    Otherwise, you can join our waitlist using the link below.
  </p>

  <a
    href="https://app.glofox.com/portal/#/branch/68b0a5af3b24dc4faa01b5d7/lead-register"
    target="_blank"
    rel="noopener noreferrer"
    className="underline font-medium"
  >
    Join the Waitlist
  </a>
</div>*/}

        <div className="flex flex-col gap-12 w-full">
          <div className="flex flex-col gap-4">
            <h1 className="text-black text-3xl xs:text-4xl leading-tight font-light uppercase">
              you&apos;re in <br /> <span className="text-4xl xs:text-5xl leading-tight font-bold">get started</span>
            </h1>
            <div>

              <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                {/* Secure Code */}
              {/*  <input
                  type="text"
                  placeholder="Secure Access Code*"
                  value={secureCode}
                  disabled
                  onChange={(e) => setSecureCode(e.target.value)}
                  className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                />*/}
          
                <input
                  type="text"
                  className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                  placeholder="First Name*"
                  value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                />
                <input
                  type="text"
                  className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                  placeholder="Last Name*"
                  value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                />
                <input
                  type="tel"
                  className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                  placeholder="Phone Number*"
                  value={phonenumber}
                  onChange={(e) => setPhonenumber(e.target.value)}
                />

                {/* Display Error Message */}
                {error && <p className="text-red-500 text-sm">{error}</p>}

                {/* Display Success Message */}
                {msg && <p className="text-green-500 text-sm">{msg}</p>}
                <button
                  type="submit"
                  className="bg-black size-12 xs:size-14 rounded-full flex justify-center items-center hover:bg-black/70 transition-all duration-300 ml-auto mt-[10px]"
                >
                  <img
                    src={arrowNext}
                    alt="arrow"
                    className="object-contain invert max-w-5 xs:max-w-6"
                  />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
